
import {themeString} from "./theme-string.js"

export const themeCss = new CSSStyleSheet()

themeCss.replaceSync(themeString)

